const lbaBooleanRestrictionSelect = angular.module('app.lbaBooleanRestrictionSelect', [])
    .filter("booleanRestrictionDisplay", () => (value) => {
        switch (value) {
            case "None":
                return "No Restriction";
            case "TrueOnly":
                return "True Only";
            case "FalseOnly":
                return "False Only";
            default:
                return "";
        }
    })
    .filter("refundableRestrictionDisplay", () => (value) => {
        switch (value) {
            case "None":
                return "No Restriction";
            case "TrueOnly":
                return "Refundable Only";
            case "FalseOnly":
                return "Non Refundable Only";
            default:
                return "";
        }
    })
    .filter("changeableRestrictionDisplay", () => (value) => {
        switch (value) {
            case "None":
                return "No Restriction";
            case "TrueOnly":
                return "Changeable Only";
            case "FalseOnly":
                return "Non Changeable Only";
            default:
                return "";
        }
    });

lbaBooleanRestrictionSelect.controller('lbaBooleanRestrictionSelectCtrl', require('./lbaBooleanRestrictionSelectCtrl'));
lbaBooleanRestrictionSelect.directive('lbaBooleanRestrictionSelect', require('./lbaBooleanRestrictionSelectDir'));
lbaBooleanRestrictionSelect.service('booleanRestrictionService', require('../../services/booleanRestrictionService'));

export default lbaBooleanRestrictionSelect;



// WEBPACK FOOTER //
// ./src/components/lbaBooleanRestrictionSelect/index.js